import { FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import { SUBLOCATION_AVAILABILITY } from '../helper/account.helper';

const MESSAGES = {
  [SUBLOCATION_AVAILABILITY.NONE_CONFIGURED]:
    "This group's chemical inventory has no sublocations yet. Chemicals are delivered to a sublocation " +
    '(a shelf, fridge, bench, or the room itself), so one must be created before you can add a delivery location.',
  [SUBLOCATION_AVAILABILITY.ALL_USED]: 'There is no other available sublocation associated with the inventory.',
  [SUBLOCATION_AVAILABILITY.ERROR]: "We couldn't load this group's sublocations.",
};

function SublocationHelp({ availability, inventoryId, onRefresh }) {
  const message = MESSAGES[availability];
  if (!message) {
    return null;
  }

  return (
    <FormHelperText id="building-error-text" className="text-red-500">
      {message}
      {availability !== SUBLOCATION_AVAILABILITY.ERROR && (
        <>
          {' '}
          <a
            href={`/inventory/chemical/${inventoryId}/sublocations`}
            target="_blank"
            rel="noopener noreferrer"
            className="underline">
            Manage sublocations
          </a>{' '}
          (requires inventory manager access), then return here and
        </>
      )}{' '}
      <button type="button" onClick={onRefresh} className="cursor-pointer underline">
        {availability === SUBLOCATION_AVAILABILITY.ERROR ? 'try again' : 'refresh'}
      </button>
      .
    </FormHelperText>
  );
}

SublocationHelp.propTypes = {
  availability: PropTypes.oneOf(Object.values(SUBLOCATION_AVAILABILITY)).isRequired,
  inventoryId: PropTypes.string.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default SublocationHelp;
